const DISMISSED_PREFIX = "harmony:persona-setup:dismissed:";

const dismissedKey = (userId: string) => `${DISMISSED_PREFIX}${userId}`;

const readFlag = (storage: Storage, key: string): boolean => {
  try {
    return storage.getItem(key) === "1";
  } catch {
    return false;
  }
};

const writeFlag = (storage: Storage, key: string): void => {
  try {
    storage.setItem(key, "1");
  } catch {
    // Private mode / quota — in-memory store still holds for this tab.
  }
};

const removeFlag = (storage: Storage, key: string): void => {
  try {
    storage.removeItem(key);
  } catch {
    // ignore
  }
};

/**
 * Atla: bu login oturumu bitene kadar (logout). Tab kapanınca da durur;
 * çıkış yapınca silinir, sonraki girişte quest tekrar açılır.
 */
export const isPersonaSetupDismissed = (userId: string): boolean => {
  const key = dismissedKey(userId);
  return readFlag(localStorage, key) || readFlag(sessionStorage, key);
};

export const dismissPersonaSetup = (userId: string): void => {
  const key = dismissedKey(userId);
  writeFlag(localStorage, key);
  removeFlag(sessionStorage, key);
};

export const clearPersonaSetupDismissed = (userId: string): void => {
  const key = dismissedKey(userId);
  removeFlag(localStorage, key);
  removeFlag(sessionStorage, key);
};
